import { render } from "./ManageTheme.vue?vue&type=template&id=bbcdfb42&lang=pug"
import script from "./ManageTheme.vue?vue&type=script&lang=js"
export * from "./ManageTheme.vue?vue&type=script&lang=js"

import "./ManageTheme.vue?vue&type=style&index=0&id=bbcdfb42&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__